import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import "./Navbar.css";
import SIALogo from "../assets/SIALogo.png";
import { Link as RouterLink } from "react-router-dom";
import CanAccess from "./access/CanAccess";
import { getTokenPayload } from "../auth";
import { canAccess } from "../permissions";
import { useAuth } from "./access/AuthContext";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import { toast, ToastContainer } from "react-toastify";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";

const NavBar = ({ users, mobileOpen, setMobileOpen, onMenuClick }) => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleLogout = () => {
    toast.error("You are being logged out.");
    logout();
    try {
      localStorage.removeItem("token");
    } catch {}
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" sx={{ minHeight: "56px" }}>
      <ToastContainer />
      <Toolbar
        className="header-toolbar"
        sx={{ minHeight: "56px !important", padding: "8px 16px" }}
      >
        {/* Sidebar Header / Toggle Button */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: mobileOpen ? "center" : "flex-end",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            onClick={() => setMobileOpen(!mobileOpen)}
            sx={{
              color: mobileOpen ? "primary.main" : "text.primary",
              transition: "color 0.3s ease, transform 0.3s ease",
              "&:hover": {
                color: "primary.main",
                transform: "scale(1.1)",
              },
            }}
          >
            {mobileOpen ? (
              <MenuOpenIcon fontSize="medium" />
            ) : (
              <MenuIcon fontSize="medium" />
            )}
          </IconButton>
        </Box>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="logo"
          sx={{ padding: "8px" }}
        >
          <img src={SIALogo} alt="sia logo" className="logo" />
        </IconButton>

        <div>
          {/* Get App Button */}
          <Button
            className="app-button"
            size="small"
            variant="contained"
            sx={{
              mr: 2,
              textTransform: "none",
              bgcolor: "#17479e",
              "&:hover": { bgcolor: "#17479e" },
              boxShadow: "0 2px 6px rgba(25,118,210,0.3)",
              fontWeight: 600,
              borderRadius: "8px",

              px: 2,
            }}
          >
            Get the App
          </Button>

          {/* Profile Avatar Button */}
          <IconButton
            onClick={handleMenu}
            sx={{
              p: 0.5,
              border: "2px solid transparent",
              "&:hover": {
                border: "2px solid #17479e",
                backgroundColor: "rgba(25,118,210,0.05)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <Avatar
              alt={user?.firstName || "User"}
              src={user?.profilePic || ""}
              sx={{
                width: 40,
                height: 40,
                bgcolor: !user?.profilePic ? "#17479e" : "transparent",
                color: "#fff",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
            >
              {!user?.profilePic && user?.firstName
                ? user.firstName.charAt(0)
                : ""}
            </Avatar>
          </IconButton>

          {/* Profile Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              elevation: 4,
              sx: {
                mt: 1.2,
                borderRadius: "8px",
                minWidth: 220,
                boxShadow: "0px 4px 16px #17469e29",
                "& .MuiMenuItem-root": {
                  transition: "all 0.2s ease",
                  borderRadius: "6px",
                  mx: 0.5,
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "#17469e29",
                },
              },
            }}
          >
            {/* <CanAccess component="NAV_PROFILE"> */}
            {/* Profile Header */}
            <MenuItem
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                py: 1.5,
                "&:hover": { backgroundColor: "transparent" },
              }}
            >
              <Avatar
                alt={user?.firstName || "User"}
                src={user?.profilePic || ""}
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: !user?.profilePic ? "#17479e" : "transparent",
                  color: "#fff",
                  fontWeight: 600,
                  textTransform: "uppercase",
                }}
              >
                {!user?.profilePic && user?.firstName
                  ? user.firstName.charAt(0)
                  : ""}
              </Avatar>
              <Box>
                <Typography fontWeight={600}>
                  {user?.firstName} {user?.lastName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user?.email || ""}
                </Typography>
              </Box>
            </MenuItem>

            {/* Profile Option */}
            {/* <MenuItem onClick={handleClose}>
              <PersonIcon sx={{ mr: 1, color: "#17479e" }} />
              {user?.roles.join(",")}
            </MenuItem> */}
            <MenuItem onClick={handleClose}>
              <PersonIcon sx={{ mr: 1, color: "#17479e" }} /> Profile
            </MenuItem>
            {/* </CanAccess> */}
            <Divider sx={{ my: 1 }} />
            {canAccess("NAV_LOGOUT") || !!getTokenPayload() ? (
              <MenuItem
                onClick={handleLogout}
                sx={{
                  color: "#ff0000",
                  fontWeight: 500,
                  "&:hover": {
                    backgroundColor: "rgba(255,0,0,0.05)",
                  },
                }}
              >
                <LogoutIcon sx={{ mr: 1, color: "#ff0000" }} /> Logout
              </MenuItem>
            ) : (
              <MenuItem
                component={RouterLink}
                to="/"
                sx={{
                  color: "#1976d2",
                  fontWeight: 500,
                  "&:hover": {
                    backgroundColor: "rgba(25,118,210,0.08)",
                  },
                }}
              >
                Login
              </MenuItem>
            )}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
